<template>
	<div class="radio">

		<input
		type="text"
		readonly="true"
		:class="inputClass"
		v-model="model">

		<div>

			<ul
			class="list-reset"
			:class="{'hidden': !active}">

				<li
				v-for="item in list">

					<label class="checkbox-hover">

						<input type="radio" :value="item.value" v-model="model" class="check-custom">

						<span class="check-toggle"></span>

						<span class="ml-2">{{ item.text }}</span>

					</label>

				</li>

			</ul>

		</div>

	</div>
</template>

<script>
	export default {

		name: 'Radio',
		props: {
			inputClass: Array,
			value: String,
			active: Boolean,
			getList: Function,
			options: Array
		},
		data () {
			return {
				model: '',
				list: [],
				timeout: null,
			}
		},
		watch: {
			model (val) {

				this.$emit('input', val)

			}
		},
		created () {

			if (this.options) this.list = this.options

		},
		methods: {
			focus () {

				this.cargarLista()

			},
			async cargarLista () {

				if (this.options) return

				const { data } = await this.getList()

				this.list = data.map(el => ({text: el, value: el}))

			}
		}
	}
</script>

<style lang="scss">

	.input-sigarus .radio {

		div {
			position: relative;
		}

		ul {
			position: absolute;
			top: 4px;
			left: 0;
			background-color: #fff;
			border-radius: .25rem;

			li {
				padding: .5rem 1rem;
			}
		}

	}

</style>
